import "slick-carousel";
import "slick-carousel/slick/slick.css";

$(document).ready(function () {
  if ($(".work-carousel").length) {
    $(".work-carousel").slick();
  }
});
